import React, { useState, useEffect } from "react";
import check_icon_new from "../../assets/images/check_icon_new.svg";
import StepItem from "./StepItem";

const Steps = ({ steps = [], onSubmit, onImageClick, imageSelected, loading = false, initialValues = {}, onOpenLocationPopup }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const handleFieldChange = (stepId, fieldLabel, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldLabel]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [fieldLabel]: false,
    }));
  };

  useEffect(() => {
    if (imageSelected) {
      setErrors((prev) => ({
        ...prev,
        image: false,
      }));
    }
  }, [imageSelected]);

  const handleCheckboxChange = (stepId, checkboxId, checked) => {
    setFormData((prev) => ({
      ...prev,
      [checkboxId]: checked,
    }));
  };

  const validatePhoneNumber = (value) => {
    if (!value) return false;
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(String(value).trim());
  };

  const validateCurrentStep = () => {
    const step = steps[currentStep - 1];
    let newErrors = {};

    step.fields?.forEach((field) => {
      if (field.label === "Phone Number") {
        if (!validatePhoneNumber(formData[field.label])) {
          newErrors[field.label] = "Phone number must be exactly 10 digits";
        }
      } else if (field.required) {
        if (field.type === "file") {
          if (!formData[field.label]) {
            newErrors[field.label] = true;
          }
        } else if (!formData[field.label] || !String(formData[field.label]).trim()) {
          newErrors[field.label] = true;
        }
      }
    });

    if (step.imageRequired && !imageSelected) {
      newErrors.image = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateCurrentStep()) return;
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevious = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleSubmit = () => {
    if (!validateCurrentStep()) return;
    onSubmit(formData);
  };

  useEffect(() => {
    if (
      initialValues &&
      typeof initialValues === "object" &&
      Object.keys(initialValues).length > 0
    ) {
      setFormData((prev) => ({
        ...prev,
        ...initialValues,
      }));
    }
  }, [JSON.stringify(initialValues)]);

  const activeStep = steps[currentStep - 1];

  return (
    <form className="steps position-relative" noValidate>
      {/* STEP CONTENT */}
      <StepItem
        key={activeStep.stepId}
        {...activeStep}
        formData={formData}
        errors={errors}
        onFieldChange={handleFieldChange}
        onCheckboxChange={handleCheckboxChange}
        onImageClick={() => onImageClick(activeStep.stepId)}
        maskFields={activeStep.maskFields}
        onOpenLocationPopup={onOpenLocationPopup}
      />


      {/* FOOTER BUTTONS */}
      <div className="step_fotter_buttons d-flex justify-content-end">
        {currentStep > 1 && (
          <button
            type="button"
            onClick={handlePrevious}
            className="btn_secondary me-2"
          >
            Previous
          </button>
        )}

        {currentStep < steps.length ? (
          <button type="button" onClick={handleNext} className="btn_primary">
            Next
          </button>
        ) : (
          <button type="button" onClick={handleSubmit} className="btn_primary" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Submitting
              </>
            ) : (
              "Submit"
            )}
          </button>
        )}
      </div>

      {/* STEP INDICATORS */}
      <div className="steps_count">
        <ul className={`steps_items step-${currentStep}`}>
          {steps.map((_, index) => {
            let className = "";
            if (index + 1 === currentStep) className = "active";
            else if (index + 1 < currentStep) className = "success";

            return (
              <li key={index}>
                <a className={className}>
                  {className === "success" ? (
                    <img src={check_icon_new} alt="done" />
                  ) : (
                    index + 1
                  )}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </form>
  );
};

export default Steps;